/**
 * react-dropzone 14+ accepts a map of MIME type to extensions.
 * Existing call sites still pass the v10 comma-separated string.
 */
const toDropzoneAccept = accept => {
  if (accept == null || typeof accept !== 'string') return accept;

  const mimeToExts = {};
  const bareExts = [];
  accept.split(',').forEach(part => {
    const token = part.trim();
    if (!token) return;
    if (token.startsWith('.')) bareExts.push(token);
    else if (!mimeToExts[token]) mimeToExts[token] = [];
  });

  const mimeTypes = Object.keys(mimeToExts);
  if (bareExts.length === 0) return mimeToExts;
  if (mimeTypes.length === 0) return { 'application/octet-stream': bareExts };
  if (mimeTypes.length === 1) {
    mimeToExts[mimeTypes[0]] = bareExts;
    return mimeToExts;
  }
  mimeTypes.forEach(mime => {
    mimeToExts[mime] = [...bareExts];
  });
  return mimeToExts;
};

export default toDropzoneAccept;
